import { IKogIcon } from "@/main/@types/interfaceIcons";

export function ReceivedIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 500.000000 399.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,399.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M1025 3953 c-149 -20 -297 -120 -375 -252 -38 -66 -366 -810 -398
          -906 -16 -46 -17 -136 -17 -1045 0 -948 1 -998 19 -1065 48 -176 175 -309 355
          -373 41 -15 153 -17 1044 -19 548 -2 997 -1 997 2 0 4 -21 33 -46 66 l-45 59
          -924 0 c-894 0 -925 1 -987 20 -94 29 -166 80 -211 149 -76 117 -71 45 -74
          1109 l-4 952 1776 0 1775 0 -6 58 c-3 31 -13 82 -21 112 -17 62 -337 785 -386
          870 -17 30 -58 83 -92 116 -62 62 -106 90 -205 128 -55 21 -60 21 -1100 22
          -575 1 -1058 -1 -1075 -3z m985 -648 l0 -525 -815 0 c-448 0 -815 3 -815 7 0
          9 327 736 365 813 44 86 91 139 155 174 98 53 108 54 628 55 l482 1 0 -525z
          m1190 489 c94 -45 141 -91 188 -181 41 -80 372 -815 372 -826 0 -4 -367 -7
          -815 -7 l-815 0 0 525 0 526 503 -3 502 -3 65 -31z"
				/>
				<path
					d="M3660 2380 c-397 -36 -754 -280 -935 -640 -141 -281 -163 -613 -61
          -923 131 -394 490 -700 907 -773 141 -24 371 -15 504 20 126 33 313 124 420
          205 139 106 278 280 347 436 80 180 110 317 109 505 0 373 -169 717 -460 935
          -240 181 -529 262 -831 235z m310 -142 c365 -60 687 -346 808 -718 65 -200 60
          -474 -12 -661 -68 -180 -127 -272 -254 -397 -209 -206 -445 -303 -737 -303
          -289 0 -539 104 -740 307 -205 207 -305 448 -305 737 0 185 32 323 113 484 93
          183 278 367 467 463 181 92 432 126 660 88z"
				/>
				<path
					d="M3960 1285 l-315 -315 -180 180 c-169 169 -182 180 -217 180 -42 0
          -58 -19 -58 -67 0 -23 37 -64 208 -235 200 -201 209 -208 247 -208 39 0 48 8
          377 338 321 321 338 339 338 374 0 40 -27 68 -64 68 -13 0 -133 -113 -336
          -315z"
				/>
			</g>
		</svg>
	);
}
